<template>
  <Base>
    <template v-slot:toolbar>
      <!-- Masque sur mobile : l'en-tete .wm-head le remplace (titre, compteur,
           recherche, action principale). Deux barres l'une sur l'autre. -->
      <div v-if="!isMobile" class="toolbar" id="kt_toolbar">
        <div class="container-fluid d-flex flex-stack" id="kt_toolbar_container">
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link :to="{name: 'dashboard'}" class="text-muted text-hover-primary">
                    <i class="fad fa-home"></i>
                    {{ trans('Dashboard') }}
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>


          <div class="d-flex align-items-center py-1">
            <div class="d-flex align-items-center">
              <div class="btn btn-icon btn-light-danger btn-xs me-2" @click="beforeMount()">
                <i class="fad fa-trash"></i>
              </div>


              <date-range-picker ref="picker" :opens="'left'" :locale-data="localData" :singleDatePicker="false"
                                 :autoApply="false" :ranges="ranges" @update="load" :timePicker="false"
                                 :showWeekNumbers="true"
                                 :showDropdowns="true" v-model="interval">
                <template v-slot:input="picker" style="min-width: 350px;">
                  <template>
                    {{ readableDate(picker.startDate, 'dmY') }} ❖ {{ readableDate(picker.endDate, 'dmY') }}
                  </template>
                </template>
              </date-range-picker>

              <!--              <div class="mx-2">-->
              <!--                du-->
              <!--              </div>-->
              <!--              <div class="mx-2">-->
              <!--                <b-form-datepicker size="sm" type="date" class="form-control" v-model="interval.start">-->
              <!--                </b-form-datepicker>-->
              <!--              </div>-->
              <!--              <div class="mx-2">-->
              <!--                au-->
              <!--              </div>-->
              <!--              <div class="mx-2">-->
              <!--                <b-form-datepicker size="sm" type="date" class="form-control" v-model="interval.end">-->
              <!--                </b-form-datepicker>-->
              <!--              </div>-->
              <!--              <div>-->
              <!--                <button class="btn btn-icon btn-sm btn-primary" @click="load">-->
              <!--                  <i class="fad fa-search"></i>-->
              <!--                </button>-->
              <!--              </div>-->
            </div>
          </div>

        </div>
      </div>
    </template>
    <template v-slot:content>
      <InsuranceDashboard :interval="interval" @period="applyPeriod"></InsuranceDashboard>
    </template>
  </Base>
</template>
<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import Base from "@/layouts/Base.vue";
import MobileAware from "@/mixins/MobileAware";
import ManagerStatistics from "@/views/Dashboard/ManagerComponent/ManagerStatistics.vue";
import InputNumber from "@/components/InputNumber.vue";
import ManagerCotations from "@/views/Dashboard/ManagerComponent/ManagerCotations.vue";
import CotationSearch from "@/views/Income/CotationSearch.vue";
import PartnerStatistic from "@/views/Partner/PartnerStatistic.vue";
import CONSTANTS from "@/Utils/constant";
import ManagerStatistic from "@/views/ManagerStatistic.vue";
import InsuranceDashboard from "@/views/Dashboard/InsuranceDashboard.vue";
import DateRangePicker from "vue2-daterange-picker";
import store from "@/store";

@Component({
  // `mixins` en OPTION : `extends mixins(...)` fait perdre le typage de Vue.
  mixins: [MobileAware],
  components: {
    InsuranceDashboard,
    ManagerStatistic,
    PartnerStatistic, ManagerCotations, InputNumber, ManagerStatistics, Base, CotationSearch, DateRangePicker
  }
})
export default class ManagerHome extends Vue {
  // Fourni par le mixin MobileAware (declaration de type seulement).
  isMobile!: boolean;

  categories = []
  search = {
    branch: null,
    after: null,
    before: null,
    contains: null,
    minimalState: 0,
    hasClientInfos: false,
    page: 1,
    statut: [] as any
  } as any

  // Periode glissante : le mois en cours affiche un dashboard vide les premiers jours du mois.
  interval = CONSTANTS.dateConstants.last_30_days();

  localData = {
    direction: 'ltr',
    format: 'mm/dd/yyyy',
    separator: ' - ',
    applyLabel: 'Valider',
    cancelLabel: 'Annuler',
    weekLabel: ' ',
    customRangeLabel: 'Custom Range',
    daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    firstDay: 0
  }
  ranges: any = false;

  resetSearch() {
    this.interval = CONSTANTS.dateConstants.last_30_days()
    let def: any = localStorage.getItem('partnerDashboardFilter')
    if (def) {
      def = JSON.parse(def)
      if (def.startDate && def.endDate) {
        this.interval = {startDate: new Date(def.startDate), endDate: new Date(def.endDate)}
      }
    }
    this.ranges = store.getters.loadRanges()
  }

  beforeMount() {
    this.resetSearch()
  }

  /** Depuis le dashboard, quand la periode selectionnee ne contient aucune production. */
  applyPeriod(period: any) {
    this.interval = period
    this.load()
  }

  /**
   * Le dashboard recharge tout seul via son watch sur `interval` :
   * on ne fait que memoriser la periode choisie.
   */
  async load() {
    localStorage.setItem('partnerDashboardFilter', JSON.stringify(this.interval))
  }
}
</script>
<style scoped>
</style>
